import Localization from './localization';
import STRINGS from './localized-strings';

export default STRINGS;

export { Localization };
